<template>
  <div class="release-data">
    <a-tabs default-active-key="1">
      <a-table size="middle" :pagination="false" :columns="columns" :data-source="tableData" row-key="release_id" :row-selection="rowSelection">
        <span slot="creator" slot-scope="text, record">
          <user-profiles :value="[record.creator.id]" />
        </span>
        <span slot="releseType" slot-scope="text, record">
          {{ record.release_type.label }}
        </span>
        <span slot="releaseEnv" slot-scope="text, record">
          {{ record.release_env.label }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :status="releaseStatus[record.status].status" :text="releaseStatus[record.status].label" />
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="onDetail(record)"> 查看 </a>
        </span>
      </a-table>
      <div class="create-release">
        <a-button type="primary" icon="plus" @click="onCreate"> 创建发布评审 </a-button>
      </div>
    </a-tabs>
  </div>
</template>
<script>
import { releaseStatus } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    dataIndex: 'release_id',
    key: 'release_id',
    align: 'center',
    minWidth: 60
  },
  {
    title: '标题',
    dataIndex: 'release_title',
    key: 'release_title',
    ellipsis: true
  },
  {
    title: '类型',
    dataIndex: 'relese_type',
    key: 'relese_type',
    align: 'center',
    scopedSlots: { customRender: 'releseType' }
  },
  {
    title: '环境',
    dataIndex: 'relese_env',
    key: 'relese_env',
    align: 'center',
    scopedSlots: { customRender: 'releaseEnv' }
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    align: 'center',
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    align: 'center',
    width: 180
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    // checked: {
    //   type: [Number, String, Array],
    //   default: null
    // },
    dataSource: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      releaseStatus,
      tableData: [],
      selectedRowKeys: [],
      rowSelection: { type: 'radio', selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange() }
    };
  },
  watch: {
    dataSource() {
      this.tableData = this.dataSource;
    }
  }
};
</script>
